export enum PageId {
  OnboardingWelcome = 'onboarding-welcome',
  OnboardingVideoTutorial = 'onboarding-video-tutorial',
  OnboardingRecommendations = 'onboarding-recommendations',
  OnboardingEmergencyContact = 'onboarding-emergency-contact',
  PlacementTestIndex = 'placement-test-index',
  PlacementTestIntro = 'placement-test-intro',
  PlacementTestPlayer = 'placement-test-player',
  PlacementTestResult = 'placement-test-result',
  ForgotPassword = 'forgot-password',
  ForgotPasswordSuccess = 'forgot-password-success',
  ForgotPasswordSubmission = 'forgot-password-submission',
  ForgotPasswordSubmissionSuccess = 'forgot-password-submission-success',
  ForgotUsername = 'forgot-username',
  ForgotUsernameSuccess = 'forgot-username-success',
  Login = 'login',
  Help = 'help',
  Level = 'level',
  Levels = 'levels',
  Unit = 'unit',
  Lesson = 'lesson',
  Profile = 'profile',
  LCHistory = 'lc-history',
  LessonIndex = 'lesson-index',
  EndOfLevelTest = 'end-of-level-test',
  Share = 'share',
  Forbidden = 'forbidden',
  Suspended = 'suspended',
  NotFound = 'not-found',
  Error = 'error',
  ZoomInstructions = 'zoom-instructions',
  PreClassActivity = 'preclass-activity',
  Play2learnZoom = 'play2learn-zoom',
  Play2learnOnboarding = 'play2learn-onboarding',
  Root = 'root',
  PlatformTourVideo = 'platform-tour-video-player',
}
